export default __webpack_public_path__ + "static/media/deliverance.54f442db.png";